import httpService from '../../utils/httpService';
import authen from '../../utils/authen';

const DEVICE_TYPE_NATURE = 3;

/** axios interceptor in utils/axios.js already returns response.data */
function unwrapResponse(res) {
  if (res == null) return null;
  if (typeof res === 'string') {
    try {
      return JSON.parse(res);
    } catch (e) {
      return null;
    }
  }
  if (typeof res === 'object' && res.data !== undefined && res.ok === undefined && res.status === undefined) {
    return res.data;
  }
  return res;
}

const initState = () => ({
  status: 'not_configured',
  message: '',
  enabled: false,
  lastPollAt: 0,
  authCheckedAt: 0,
  natureUsername: '',
  natureBaseUrl: 'http://mangnuocvn.com',
  hasPassword: false,
  lastTestOk: false
});

const natureIntegration = {
  namespaced: true,
  state: initState(),
  getters: {
    natureAuthStatus: state => state.status,
    natureAuthMessage: state => state.message,
    showNatureAuthBanner: state =>
      state.status === 'invalid_credentials' || state.status === 'network_error',
    isNatureTestOk: state => state.lastTestOk || state.status === 'ok',
    hasNaturePassword: state => state.hasPassword
  },
  mutations: {
    SET_NATURE_STATUS(state, payload) {
      if (!payload) return;
      state.status = payload.status || 'not_configured';
      state.message = payload.message || '';
      state.enabled = !!payload.natureEnabled;
      state.lastPollAt = payload.lastPollAt || 0;
      state.authCheckedAt = payload.authCheckedAt || 0;
      state.natureUsername = payload.natureUsername || '';
      state.natureBaseUrl = payload.natureBaseUrl || 'http://mangnuocvn.com';
      state.hasPassword = !!payload.hasPassword;
      if (payload.status === 'ok') state.lastTestOk = true;
    },
    SET_NATURE_FROM_READ_USER(state, integration) {
      if (!integration) return;
      state.status = integration.status || 'not_configured';
      state.message = integration.message || '';
      state.enabled = !!integration.enabled;
      state.lastPollAt = integration.lastPollAt || 0;
      state.authCheckedAt = integration.authCheckedAt || 0;
    },
    SET_NATURE_TEST_OK(state, ok) {
      state.lastTestOk = !!ok;
    },
    RESET_NATURE(state) {
      Object.assign(state, initState());
    }
  },
  actions: {
    FETCH_NATURE_STATUS({ commit }, payload = {}) {
      return httpService.methods.$post(
        'NatureAPI/GetNatureStatus',
        JSON.stringify({
          tokenkey: payload.tokenkey || authen.getToken(),
          targetUsername: payload.targetUsername || ''
        })
      ).then(res => {
        const data = unwrapResponse(res);
        if (data && typeof data === 'object' && data.status) {
          commit('SET_NATURE_STATUS', data);
        }
        return data;
      });
    },
    TEST_NATURE_CONNECTION({ commit }, payload) {
      return httpService.methods.$post(
        'NatureAPI/TestConnection',
        JSON.stringify({
          tokenkey: payload.tokenkey || authen.getToken(),
          targetUsername: payload.targetUsername || '',
          natureBaseUrl: payload.natureBaseUrl,
          natureUsername: payload.natureUsername,
          naturePassword: payload.naturePassword || ''
        })
      ).then(res => {
        const data = unwrapResponse(res);
        if (data && data.ok) commit('SET_NATURE_TEST_OK', true);
        else commit('SET_NATURE_TEST_OK', false);
        if (data && data.status) {
          commit('SET_NATURE_STATUS', {
            status: data.status,
            message: data.message,
            natureEnabled: data.ok
          });
        }
        return data;
      });
    },
    SAVE_NATURE_CREDENTIALS(_, payload) {
      return httpService.methods.$post(
        'NatureAPI/SaveCredentials',
        JSON.stringify({
          tokenkey: payload.tokenkey || authen.getToken(),
          targetUsername: payload.targetUsername || '',
          natureBaseUrl: payload.natureBaseUrl,
          natureUsername: payload.natureUsername,
          naturePassword: payload.naturePassword || '',
          natureEnabled: true
        })
      ).then(res => unwrapResponse(res));
    },
    DISCOVER_NATURE_STATIONS(_, payload) {
      return httpService.methods.$post(
        'NatureAPI/DiscoverStations',
        JSON.stringify({
          tokenkey: payload.tokenkey || authen.getToken(),
          targetUsername: payload.targetUsername || ''
        })
      ).then(res => unwrapResponse(res));
    },
    IMPORT_NATURE_STATIONS(_, payload) {
      return httpService.methods.$post(
        'NatureAPI/ImportStations',
        JSON.stringify({
          tokenkey: payload.tokenkey || authen.getToken(),
          targetUsername: payload.targetUsername,
          username: payload.targetUsername,
          area: payload.area,
          natureStations: payload.stations
        })
      ).then(res => unwrapResponse(res));
    },
    APPLY_READ_USER_NATURE({ commit, rootState }, readUserResponse) {
      if (readUserResponse && readUserResponse.nature_integration) {
        commit('SET_NATURE_FROM_READ_USER', readUserResponse.nature_integration);
      }
      const devices = (readUserResponse && readUserResponse.list_devices) || [];
      const hasNature = devices.some(d => d.type === DEVICE_TYPE_NATURE);
      if (hasNature && readUserResponse.nature_integration) {
        commit('SET_NATURE_FROM_READ_USER', readUserResponse.nature_integration);
      }
      return hasNature;
    }
  }
};

export { DEVICE_TYPE_NATURE };
export default natureIntegration;



// WEBPACK FOOTER //
// ./src/store/modules/natureIntegration.js